if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });

        this.syncDropdownsToSelectedVariant();

        this.querySelectorAll('select').forEach((select) => {
          this.updateSelectedSwatchValue({ target: select });
        });

        // Re-apply after the browser finishes any form session restoration,
        // which can otherwise reset the dropdown to a previously used value.
        requestAnimationFrame(() => {
          this.syncDropdownsToSelectedVariant();
          this.querySelectorAll('select').forEach((select) => {
            this.updateSelectedSwatchValue({ target: select });
          });
        });
      }

      syncDropdownsToSelectedVariant() {
        const dataEl = this.querySelector('[data-selected-variant]');
        if (!dataEl) return;

        let variant;
        try {
          variant = JSON.parse(dataEl.textContent);
        } catch (error) {
          return;
        }
        if (!variant || !Array.isArray(variant.options)) return;

        this.querySelectorAll('select').forEach((select, index) => {
          const expectedValue = variant.options[index];
          if (expectedValue == null) return;

          const matchingOption = Array.from(select.options).find((option) => option.value === expectedValue);
          if (matchingOption && !matchingOption.selected) {
            select.value = expectedValue;
          }
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options).forEach((option) => option.removeAttribute('selected'));
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
